import React from 'react';
import PropTypes from 'prop-types';
import {Button, Card, Heading} from 'rebass'
import {AdaptedInput} from "./FormField";
import {Field, Form} from 'react-final-form'

import {buttonMarginTop, PopupWrapper} from "./styles";

const NewCalendarCategory = props => {
	const {onSubmit, toggleOverlay} = props;



	return (
		<PopupWrapper>
				<Form
					onSubmit={onSubmit}
					render={({ handleSubmit, form, submitting, pristine, values }) => {
						return (
							<form id="exampleForm" onSubmit={handleSubmit}>
								<Heading>New Category</Heading>
								<Button variant={'main'} m={1} mt={buttonMarginTop}
								        bg={pristine ? 'meta' : 'green'}
								        disabled={pristine}
								        type="submit"

								>
									Save
								</Button>
								<Button variant={'main'} m={1} mt={buttonMarginTop} bg={'gray'} onClick={(e) =>{
									e.preventDefault();
									form.reset()
									toggleOverlay()
								}}>Cancel</Button>

								<Heading as={'h5'} mt={3}>Name</Heading>
								<Card boxShadow={'main'}>

								<Field
									name="name"
									component={AdaptedInput}
									type="text"
									placeholder="Name goes here..."
								/>
								</Card>

							</form>
						)
					}}
				/>
		</PopupWrapper>
	);
};

NewCalendarCategory.propTypes = {
	onSubmit: PropTypes.func
};

NewCalendarCategory.defaultProps = {
	onSubmit: (values) => console.log('New Category values', values)
};
export default NewCalendarCategory;
